<h2 color="primary">ログイン</h2>
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}
<div class="login-container">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmitLogin(loginForm.value)" autocomplete="on">
    <div class="category-container">
      <div>
        <label>ID</label>
      </div>
      <div>
        <input id="email" class="text-input" type="email" formControlName="email" />
      </div>
    </div>

    <div class="category-container">
      <div>
        <label>パスワード</label>
      </div>
      <div>
        <input class="text-input" type="password" formControlName="password" />
      </div>
      @if (password.invalid && password.touched) {
        <mat-error class="error-text">
          パスワードを入力してください。
        </mat-error>
      }
    </div>
    <div class="footer-container">
      <button class="login-button" type="submit">ログイン</button>
    </div>

    <div class="attention">
      IDやパスワードを忘れた場合は管理者にお問い合わせください。
    </div>

    <div class="new-regist">
      <div class="text">
        初めてご利用の方
      </div>
      <button mat-raised-button (click)="onSignUp()" class="new-btn">新規アカウント登録</button>
    </div>

  </form>
</div>
<div class="attention long">
  <b>推奨環境</b>
  <div class="text">
    Chrome, EdgeのPC全画面表示（横幅1440px以上）でご利用ください。
  </div>
</div>
